export default __webpack_public_path__ + "static/media/notes_list_background.8a0917c8.jpg";